export const REGEX_EMAIL_VALIDATION = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const REGEX_PASSWORD_VALIDATION = new RegExp('^(?=.*?[a-zA-Z])(?=.*?[0-9]).{8,}$');
export const REGEX_SEARCH_FILTER_NO_SPECIAL_CHARS = /[^\w\s_-]/gi;
